/*
 * Redux reducers live here. Read Redux docs for more information:
 * http://redux.js.org/docs/basics/Reducers.html
 */

import { combineReducers } from "redux";

import entities from "./entities";
import modals from "./modals";
import navPoint from "./navPoint";
import notifications from "./notifications";
import productEdit from "./productEdit";
import uploads from "./uploads";
import user from "./user";

const rootReducer = combineReducers({
  entities,
  modals,
  navPoint,
  notifications,
  productEdit,
  uploads,
  user,
});

export default rootReducer;
